import React from 'react';
import translate from '@/utils/translate';
import BriefSection from './BriefSection';
import CopyableValue from './CopyableValue';

interface DiscountCodeItemProps {
  code: string;
}

/**
 * `discountCode` is already gated on the campaign being an affiliate one, so Ember's
 * no-code placeholder branch is unreachable from here.
 */
function DiscountCodeItem({code}: DiscountCodeItemProps) {
  return (
    <BriefSection
      testID="brief-discount-code"
      title={translate('Coupon Code For Posting')}
      subtitle={translate(
        'You must include the discount code with your post as specified below'
      )}
    >
      <CopyableValue testID="brief-discount-code-value" value={code} />
    </BriefSection>
  );
}

export default DiscountCodeItem;
